import React, { memo } from 'react';

interface ApplicationTimestampsProps {
  createdAt: any;
  updatedAt: any;
}

const formatDate = (timestamp: any) => {
  if (!timestamp) return '날짜 정보 없음';

  let date: Date;
  if (timestamp.toDate) {
    // Firestore Timestamp 객체인 경우
    date = timestamp.toDate();
  } else if (timestamp instanceof Date) {
    // 일반 Date 객체인 경우
    date = timestamp;
  } else {
    // 문자열이나 다른 형식인 경우
    date = new Date(timestamp);
  }

  return date.toLocaleString('ko-KR', {
    year: 'numeric',
    month: 'long',
    day: 'numeric',
    hour: '2-digit',
    minute: '2-digit'
  });
};

const ApplicationTimestampsComponent: React.FC<ApplicationTimestampsProps> = ({
  createdAt,
  updatedAt
}) => {
  return (
    <div className="mt-6 md:mt-8">
      <div className="flex flex-col sm:flex-row sm:justify-between gap-4 sm:gap-0 text-[#6b7684] text-sm md:text-lg font-medium">
        <div>
          <p className="mb-1 md:mb-2">신청일시</p>
          <p className="text-[#1e2c49] text-sm md:text-base break-all">{formatDate(createdAt)}</p>
        </div>
        <div>
          <p className="mb-1 md:mb-2">마지막 수정</p>
          <p className="text-[#1e2c49] text-sm md:text-base break-all">{formatDate(updatedAt)}</p>
        </div>
      </div>
    </div>
  );
};

export const ApplicationTimestamps = memo(ApplicationTimestampsComponent);
